import { render, staticRenderFns } from "./ClientApp.vue?vue&type=template&id=9178a2a2&"
import script from "./ClientApp.vue?vue&type=script&lang=js&"
export * from "./ClientApp.vue?vue&type=script&lang=js&"
import style0 from "./ClientApp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports